import type { FaireProductEntity } from "../../entity_types/product";

export const p_4hfx0wq9: FaireProductEntity = {
  token: "p_4hfx0wq9",
  type: "product",
  name: "My Cat Says You're Dumb Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/res/hszgttpjt/image/upload/241bde8381941a90890bb1a2540b96e9edf7bbfa94659437cea4cb34b7e460da/1544664965.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/573a36fb36b27d01a6943e015a396968418ab94eeb91054e8bf8d071740fde9a/1555102281.jpg",
    "https://cdn.faire.com/fastly/d8ec170f19f22e0a10715ec2b2757e09a463156b73712f619a366e5761ce1528.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/80a7b41a4d6bb402d8aa31f48a86b48c7f457d3132f045807a8f5f11164b953e.jpeg"
  ],
  priceDollars: 6.75,
  description: "To be fair, your cat thinks everyone is dumb… so these socks are never lying!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:54.429Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
